// extracted by mini-css-extract-plugin
module.exports = {"searchWrapper":"SearchInput_searchWrapper__A9C1e","sticky":"SearchInput_sticky__hznsA","searchIcon":"SearchInput_searchIcon__1M4qS","searchInput":"SearchInput_searchInput__FfT73"};